import * as React from "react";
const LeftBubble = (props) => (
  <svg
    width={166}
    height={115}
    viewBox="0 0 166 115"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M114.931 37.5939C80.1372 39.3861 70.5922 8.87971 41.2782 1.7375C10.0602 -5.8721 -4.0298 13.0603 -7.3661 28.5398C-9.9379 40.4724 -15.3436 45.652 -29.5907 48.9699C-39.7454 50.8329 -48.7434 56.1101 -46.3866 70.5852C-44.0297 85.0603 -48.8069 93.7033 -55.9183 98.8813C-63.0297 104.06 -69.6644 111.412 -71.9979 120.99C-75.9503 137.203 -67.9156 154.185 -53.1073 161.714C-36.4668 169.995 -27.5298 179.06 -28.6986 197.861C-28.9907 202.56 -27.0298 227.56 -3.23779 220.003C2.77121 218.095 27.6292 205.224 42.7142 229.112C46.4702 235.06 55.7712 240.913 64.2702 242.987C87.0622 248.541 110.364 231.739 112.678 208.604C115.188 191.486 118.302 183.459 136.807 189.438C155.117 195.354 166.074 169.869 155.829 156.795C141.61 142.06 158.577 115.56 163.965 93.4483C171.33 63.2239 145.302 34.3022 114.931 37.5939Z"
      fill="#FEF5EB"
    />
  </svg>
);
export default LeftBubble;
